import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import Modal from "shared/components/Modal";
import { COLOR_BLACK } from "shared/theme/colors";
import { useArticleGroupPage } from "../../context";

type Props = {
  open: boolean;
  onClose: () => void;
};

const DeletingArticleModal: FC<Props> = ({ open, onClose }) => {
  const { handleDeletingArticleDetails, isLoadingDeleteArticle } =
    useArticleGroupPage();

  const onSubmit = () => {
    handleDeletingArticleDetails();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Permanently Delete File?"
      primaryButtonTitle="Delete Permanently"
      primaryColor="error"
      secondaryButtonTitle="Cancel"
      onSecondaryClick={onClose}
      onPrimaryClick={onSubmit}
      isSubmitting={isLoadingDeleteArticle}
    >
      <Typography variant="bodyMRegular" color={COLOR_BLACK}>
        Deleting this file is permanent and cannot be undone. Do you want to
        continue?
      </Typography>
    </Modal>
  );
};

export default DeletingArticleModal;
